import React, { useState } from "react";
import { Button, ConfirmDialog } from "components";
import Provider from "provider";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectGameId } from "features/gamestate/gameStateSlice";
import logging from "utils/logging";

const log = logging.getLogger("Game Settings");

const DeleteGameButton = () => {
  const gameId = useSelector(selectGameId);
  const navigate = useNavigate();

  const [deleting, setDeleting] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const deleteGame = async () => {
    setDeleting(true);
    setConfirmOpen(false);

    try {
      const result = await Provider.deleteGame(gameId);
      log.debug("delete game result: ", result);
      // Redirect to the manage screen
      navigate("/manage");
    } catch (e) {
      log.error("Error deleting game: ", e);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <React.Fragment>
      <Button
        size="lg"
        variant="danger"
        onClick={() => setConfirmOpen(true)}
        disabled={deleting}
      >
        Delete Game
      </Button>

      <ConfirmDialog
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={deleteGame}
        confirmLabel="Delete Game"
        destructive
        loading={deleting}
        message={
          <>
            This will permanently delete this game including questions and any
            history/results it may have.
            <br />
            <br />
            Would you like to delete this game?
          </>
        }
      />
    </React.Fragment>
  );
};

export default DeleteGameButton;
